import { z } from "zod";

const PHONE_PATTERN = /^[0-9+\-()\s.]+$/;
const MIN_PHONE_DIGITS = 6;

const isValidPhone = (value) => {
  if (!value) return true;
  const digits = (value.match(/\d/g) || []).length;
  return PHONE_PATTERN.test(value) && digits >= MIN_PHONE_DIGITS;
};

export const leadSchema = z.object({
  name: z.string().trim().min(2, "Please enter your name.").max(120),
  company: z.string().trim().min(2, "Please enter your organization.").max(160),
  role: z.string().trim().min(2, "Please enter your role.").max(120),
  email: z.string().trim().email("Please enter a valid work email."),
  phone: z.string().trim().optional().refine(isValidPhone, "Please enter a valid phone number."),
  message: z.string().trim().max(2000, "Please keep your message under 2000 characters.").optional(),
  interest: z.string().optional(),
  website: z.string().max(0).optional(), // honeypot — must stay empty
});

export const emptyLead = (interest) => ({
  name: "",
  company: "",
  role: "",
  email: "",
  phone: "",
  message: "",
  interest,
  website: "",
});

/** Normalises an axios error into a user-facing message. */
export const describeSubmitError = (err) => {
  const detail = err?.response?.data?.detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg).join(" ");
  return detail || "Something went wrong. Please try again or email us directly.";
};
